
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import EditApprovedUsers from './editApprovedUsers';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class ViewEditApprovedUserSInfo extends Component {
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'User Status',
                content: <EditApprovedUsers />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewEditApprovedUserSInfo
